import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  TemplateRef
} from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { User } from '../../../../../models/User';
import { CustomItemContext } from 'app/components/data-table/data-table.component';
import { PieChartData } from '../../../charts/models/PieChartData';

@Component({
  selector: 'top-sub-domains',
  templateUrl: './top-sub-domains.html',
  styleUrls: ['./top-sub-domains.css']
})
export class TopSubDomains implements OnInit, OnChanges {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() isFollowing: boolean;
  @Output() anchorClick: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('domainTemplate', { static: true })
  domainTemplate: TemplateRef<CustomItemContext>;

  headers = [];
  subdomains = [];
  percPipe = new PercPipe();
  isFreemium: boolean;
  pieChartData: Array<PieChartData> = [];

  constructor(private userService: User) {}

  ngOnInit() {
    this.isFreemium = this.userService.isFreemium();
    this.prepareData();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.prepareData();
  }

  prepareData() {
    if (
      this.data['subDomainDistribution'] &&
      this.data['subDomainDistribution']['subDomains']
    ) {
      const subdomains = JSON.parse(
        JSON.stringify(this.data['subDomainDistribution']['subDomains'])
      );
      this.headers = [];
      this.headers.push({ class: 'col-4', text: 'HOST', key: 'adDomain' });
      this.headers.push({
        class: 'col text-right',
        text: 'CONTRIB %',
        format: 'percent',
        key: 'totalTrafficRatio',
        lockedInFreemium: true
      });
      this.headers.push({
        class: 'col text-right',
        text: 'MASKING %',
        format: 'percent',
        key: 'maskingRatio',
        lockedInFreemium: true
      });
      this.headers.push({
        class: 'col text-right',
        text: 'IVT %',
        format: 'percent',
        key: 'givtSivtRate',
        lockedInFreemium: !this.isFollowing
      });
      this.headers.push({
        class: 'col text-right',
        text: 'Viewability %',
        format: 'percent',
        key: 'nonGivtSivtViewability'
      });

      for (const subDomain of subdomains) {
        const adDomain = subDomain['adDomain'];
        subDomain['adDomainTemplate'] = this.domainTemplate;
        subDomain['adDomainRouterLink'] = [
          '/insight/domains',
          adDomain,
          this.region,
          this.device
        ];
      }

      this.subdomains = subdomains;

      if (this?.data?.subDomainDistribution?.subDomains) {
        this.pieChartData = this?.data?.subDomainDistribution?.subDomains.map(
          item => {
            return {
              category: item?.adDomain,
              value: parseFloat(
                (item?.totalTrafficRatio * 100).toString()
              ).toFixed(2),
              title: item?.adDomain
            };
          }
        );
      }
    }
  }
}
